import { render } from "./realNameReject.vue?vue&type=template&id=faac2046&scoped=true"
import script from "./realNameReject.vue?vue&type=script&lang=js"
export * from "./realNameReject.vue?vue&type=script&lang=js"

import "./realNameReject.vue?vue&type=style&index=0&id=faac2046&lang=scss&scoped=true"

import exportComponent from "/root/workspace/zyy-iot_zyy-iot-web-v2_ZubV/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faac2046"]])

export default __exports__